module.exports = __webpack_public_path__ + "img/open-right.d03dede5.svg";